import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FileWithTreeLinesOutline = createIcon({
  displayName: 'FileWithTreeLinesOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M19.12132,6.12132,16.87868,3.87868A3,3,0,0,0,14.75736,3H7A3,3,0,0,0,4,6V18a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V8.24264A3,3,0,0,0,19.12132,6.12132Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,8.5H16.5a2,2,0,0,1-2-2V3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="16"
        y1="16.5"
        x2="8"
        y2="16.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8"
        y1="13"
        x2="16"
        y2="13"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="10.7"
        y1="9.5"
        x2="8"
        y2="9.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const FileWithTreeLines: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FileWithTreeLinesTwoTone} {...props} />

  return <CustomIcon as={FileWithTreeLinesOutline} {...props} />
}

export default memo(FileWithTreeLines)
